import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { dxButtonOptions } from 'devextreme/ui/button';
import { Router } from '@angular/router';
import { TemplateService } from '../../Services/template.service';
import { NewsService } from '../../Services/news.service';
import { UserManagementService } from '../../Services/userManagment.service';
import notify from 'devextreme/ui/notify';
import { ValidationService } from '../../Services/Validation/validation.service';
import { OxomiSortimentService } from 'app/Services/oxomiSortiment.service';
import { SignalrService } from '../../Services/signalr.service';
import { takeUntil } from 'rxjs/operators';
import { NavigationMenuItem } from '../../Model/Navigation/NavigationMenuItem';
import { DATAPROCESS_NAVIGATION_MENU, NAVIGATION_MENU } from './navigation-menu.config';
import { LoginService } from '../../Services/login.service';
import { SystemService } from '../../Services/system.service';
import { CatalogService } from '../../Services/CatalogManagement/catalog.service';
import { JobListComponent } from "../../Jobs/jobList.component";

@Component({
    selector: 'menu',
    templateUrl: 'menu.component.html',
    styleUrls: ['menu.component.css']
})
export class MenuComponent implements OnInit, OnDestroy {
    drawerTimeout: NodeJS.Timeout = undefined;

    drawerOpened: boolean = false;
    drawerFocused: boolean = false;
    menuButtonOptions: dxButtonOptions;
    jobsButtonOptions: dxButtonOptions;
    newsButtonOptions: dxButtonOptions;
    accountButtonOptions: dxButtonOptions;
    warningButtonOptions: dxButtonOptions;
    newImport: boolean = true;
    newNews: boolean = false;
    loggedInSubscription: any = null;
    currentNavigationTitle = '';
    jobBadgeLastState: string = "";
    jobbadgeclass: string = 'jobbagde-info';
    jobbadgevisible: boolean = false;
    logoUrl: string = '/images/nextpim logo_transp_weiß_2.svg';

    oxomiUpdateAvailable: boolean = false;

    sendToCustomerPopupOpen = false;

    @ViewChild("jobDetailCmp")
    jobListCmp!: JobListComponent;
    isJobWarningVisible: boolean = false;
    public templateEditorVisible: boolean = false;

    isDataProcessOpen: boolean = true;

    constructor(
        private router: Router,
        public templateService: TemplateService,
        public translate: TranslateService,
        public newsService: NewsService,
        public userManagemant: UserManagementService,
        private cdr: ChangeDetectorRef,
        private oxomiService: OxomiSortimentService,
        private validationService: ValidationService,
        private signalrService: SignalrService,
        public loginService: LoginService,
        private systemService: SystemService,
        private catalogService: CatalogService
    ) {
        this.drawerMouseEnter = this.drawerMouseEnter.bind(this);
        this.drawerMouseLeave = this.drawerMouseLeave.bind(this);
        this.updateMenuButtons = this.updateMenuButtons.bind(this);
        this.onLoggedIn = this.onLoggedIn.bind(this);
        this.showNews = this.showNews.bind(this);
        this.logout = this.logout.bind(this);

        this.menuButtonOptions = {
            icon: 'menu',
            onClick: () => {
                this.drawerOpened = !this.drawerOpened;
            }
        };

        this.accountButtonOptions = {
            elementAttr: { id: 'accountToolTip' },
            hint: `Account: ${this.account}`,
            icon: 'user',
            onClick: this.showAccount.bind(this)
        };

        translate.get('Jobs').subscribe((value) => {
            this.jobsButtonOptions = {
                elementAttr: { id: 'jobsToolTip' },
                hint: value,
                icon: 'runner',
                onClick: this.showJobs.bind(this)
            };
        });

        this.newsButtonOptions = {
            elementAttr: { id: 'newsButtonOptions' },
            icon: 'email',
            type: 'normal',
            onClick: this.showNews.bind(this)
        };
    }

    get isJobRunning(): boolean {
        return this.catalogService.isJobRunning;
    }

    get dataProcessNavigation() {
        const userLoggedIn = this.loginService.currentUser ? true : false;
        DATAPROCESS_NAVIGATION_MENU.forEach(item => item.visible = userLoggedIn && item.hasRequiredAddons(this.loginService) && item.isUserAllowedToView(!this.canView(item.path)));
        return DATAPROCESS_NAVIGATION_MENU;
    }

    get navigation() {
        const userLoggedIn = this.loginService.currentUser ? true : false;
        NAVIGATION_MENU.find(item => item.path === "productReportDesigner").linkDisabled = !this.loginService.hasAddonREPORTPRODUCTDATASHEET;
        NAVIGATION_MENU.forEach(item => item.visible = userLoggedIn && item.hasRequiredAddons(this.loginService) && item.isUserAllowedToView(!this.canView(item.path)));
        return NAVIGATION_MENU;
    }

    get selectedNavigationItems() {
        var selectedNavigationItems: NavigationMenuItem[] = [];
        selectedNavigationItems.push(...DATAPROCESS_NAVIGATION_MENU.filter((ni) => this.router.url?.startsWith(`/${ni.path}`)));
        selectedNavigationItems.push(...NAVIGATION_MENU.filter((ni) => this.router.url?.startsWith(`/${ni.path}`)));
        return selectedNavigationItems;
    }

    get jobsVisible(): boolean {
        return this.catalogService.viewService.jobsVisible;
    }

    set jobsVisible(value: boolean) {
        this.catalogService.viewService.jobsVisible = value;
    }

    get currentUser() {
        if (this.loginService.currentUser) {
            return this.loginService.currentUser;
        } else return '';
    }

    get currentAccount() {
        if (this.loginService.currentCustomer?.name) {
            return this.loginService.currentCustomer.name;
        }
        return '';
    }

    get canChangePassword() {
        if (this.loginService.currentUser) {
            return true;
        }
        return false;
    }

    get isNoLayoutPage(): boolean {
        if (this.router.url.startsWith('/getProduct')) {
            return true;
        }
        if (this.router.url.startsWith('/printChart')) {
            return true;
        }

        return false;
    }

    get canLanguages() {
        if (this.loginService.currentUser) {
            return true;
        }
        return false;
    }

    get canAccount() {
        if (this.loginService.currentUser) {
            return true;
        }
        return false;
    }

    get canLayers() {
        if (this.loginService.currentUser) {
            return true;
        }
        return false;
    }

    get getViewPort() {
        return this.loginService.getViewPort();
    }

    get isOnboarding() {
        return this.loginService.hasAddonONBOARDING;
    }

    get fullScreen() {
        return this.catalogService.viewService.fullScreen;
    }

    set fullScreen(value) {
        this.catalogService.viewService.fullScreen = value;
    }

    get accountMenuVisible() {
        return this.catalogService.accountMenuVisible;
    }

    set accountMenuVisible(value: boolean) {
        this.catalogService.accountMenuVisible = value;
    }

    get userName() {
        if (this.loginService.currentUser == null) return '';
        var name =
            this.loginService.currentUser.firstName + ' ' + this.loginService.currentUser.lastName;

        if (this.isAdmin()) {
            name = name + ' (ADMIN)';
        }

        return name;
    }

    get account() {
        if (this.loginService.currentCustomer) return this.loginService.currentCustomer.name;
        return '';
    }

    get hasNewNews() {
        return this.newsService.newNews;
    }

    async ngOnInit() {
        const url = this.router.url.toLowerCase();
        if (url.includes('gastro')) {
            this.logoUrl = '/images/gastroPIM_invertiert.png';
        }
        if (this.loginService.currentCustomer.isGastro) {
            this.logoUrl = '/images/gastroPIM_invertiert.png';
        }

        // Fill property once it changes
        this.systemService.titleUpdate$.subscribe((title) => {
            if (title) {
                this.currentNavigationTitle = title;
            } else {
                const itemTitle = NAVIGATION_MENU.find((ni) => this.router.url?.startsWith(`/${ni.path}`));
                if (itemTitle) {
                    this.currentNavigationTitle = itemTitle.text as string;
                }
            }

            // Bugfix for ExpressionChangedAfterItHasBeenCheckedError
            this.cdr.detectChanges();
        });
        if (this.loginService.loggedIn) {
            await this.onLoggedIn();
        } else {
            this.loggedInSubscription = this.loginService.onLoggedIn.subscribe(() => this.onLoggedIn());
        }

        this.oxomiService.getUpdateForSupplierAvailable(this.loginService.currentCustomer.id);
    }

    //Style

    ngOnDestroy() {
        try {
            if (this.loggedInSubscription != null) this.loggedInSubscription.unsubscribe();
        } catch {
        }
    }

    ttt() {
        this.isJobWarningVisible = !this.isJobWarningVisible;
    }

    //ImportTemplate

    drawerMouseEnter(e) {
        const self = this;

        this.drawerTimeout = setTimeout(() => {
            self.drawerFocused = true;

            clearTimeout(self.drawerTimeout);
            self.drawerTimeout = undefined;
        }, 1000);
    }

    drawerMouseLeave(e) {
        const self = this;

        if (this.drawerTimeout) {
            clearTimeout(this.drawerTimeout);
            this.drawerTimeout = undefined;
        }

        this.drawerFocused = false;
    }

    loadView(e) {
        this.router.navigate([e.addedItems[0].filePath]);
    }

    showJobs() {
        this.jobbadgevisible = false;
        this.jobBadgeLastState = "";
        this.catalogService.viewService.jobsVisible = !this.catalogService.viewService.jobsVisible;

        this.jobListCmp?.startRefreshing();
    }

    public showNews() {
        this.router.navigate(['/newsArticle']);
    }

    public switchImport() {
        if (this.newImport) {
            this.newImport = false;
        } else {
            this.newImport = true;
        }
    }

    async onLoggedIn() {
        this.updateMenuButtons();
        this.loginService.notifyTestAccount();
        this.loginService.onNewNewsAmountChanged.subscribe(() => {
            this.newsService.checkNewNews();
        });

        this.signalrService.showJobRunningWarning$.pipe(takeUntil(this.signalrService.clearSubscriptions$)).subscribe((x) => {
            this.catalogService.isJobRunning = x;
        })

        await this.signalrService.startCustomerFeed(this.loginService.currentCustomer.id);
        this.signalrService.ShowJobFinishedNotification$.pipe(takeUntil(this.signalrService.clearSubscriptions$)).subscribe((x) => {
            if (x.jobType === 'ExportToCustomerWithValidation' && localStorage.sendToCustomerSuccess !== 'true') {
                // Im Moment soll es immer ausgelöst werden.
                // Kommt die Anforderung, dass es zu nervig ist, dann einfach wieder auskommentieren.
                // localStorage.sendToCustomerSuccess = 'true';

                this.sendToCustomerPopupOpen = true;
                return;
            }

            if (!x?.jobName || this.jobsVisible) return;
            this.setJobBadeStatus(x.jobState);
            let position = { right: 1, top: 64 };
            let message =
                x.jobState == 'error' ? 'Job auf Fehler gelaufen' : x.jobState == 'warning' ? 'Job hat Warnung' : 'Job ist beendet';
            notify(
                {
                    message: this.translate.instant(message, { jobname: x.jobName }),
                    height: 50,
                    width: 300,
                    type: x.jobState,
                    displayTime: 3500
                },
                { position: position, direction: 'down-push' }
            );
            if (x.jobName.includes('CalculateProductDataQuality')) {
                this.validationService.validationResultChanged.emit('CalculateProductDataQuality job finished');
            }
        });
    }

    setJobBadeStatus(newJobState: string) {

        console.log(newJobState);
        switch (this.jobBadgeLastState) {
            case "error":
                break;
            case "warning":
                if (newJobState == "error") {
                    this.jobBadgeLastState = newJobState;
                    this.jobbadgevisible = true;
                    this.jobbadgeclass = 'jobbagde-' + newJobState;
                }
                break;
            case "success":
                if (newJobState == "error" || newJobState == "warning") {
                    this.jobBadgeLastState = newJobState;
                    this.jobbadgevisible = true;
                    this.jobbadgeclass = 'jobbagde-' + newJobState;
                }
                break;
            case "info":
                this.jobBadgeLastState = newJobState;
                this.jobbadgevisible = true;
                this.jobbadgeclass = 'jobbagde-' + newJobState;
                break;
            default:
                this.jobBadgeLastState = newJobState;
                this.jobbadgevisible = true;
                this.jobbadgeclass = 'jobbagde-' + newJobState;
                break;
        }
    }


    updateMenuButtons() {
        if (this.loginService.currentCustomer) {
            this.accountButtonOptions = {
                elementAttr: { id: 'accountToolTip' },
                hint: `Account: ${this.account}`,
                icon: 'user',
                onClick: this.showAccount.bind(this)
            };
        } else {
            this.accountButtonOptions = {
                elementAttr: { id: 'accountToolTip' },
                hint: `Account: Not logged in`,
                icon: 'user',
                onClick: this.showAccount.bind(this)
            };
        }

        this.translate.get('Jobs').subscribe((value) => {
            this.jobsButtonOptions = {
                elementAttr: { id: 'jobsToolTip' },
                hint: value,
                icon: 'runner',
                onClick: this.showJobs.bind(this)
            };
        });

        this.newsButtonOptions = {
            elementAttr: { id: 'newsButtonOptions' },
            icon: 'email',
            type: 'normal',
            onClick: this.showNews.bind(this)
        };
    }

    public toFullScreen() {
        this.fullScreen = true;
    }

    public toWindow() {
        this.fullScreen = false;
    }

    showAccount() {
        this.catalogService.accountMenuVisible = !this.catalogService.accountMenuVisible;
    }

    hideAccountMenu() {
        this.catalogService.accountMenuVisible = false;
    }

    async logout() {
        await this.loginService.logout();
        this.hideAccountMenu();
        this.router.navigate(['/login']);
    }

    isOpened(): boolean {
        return this.drawerOpened || this.drawerFocused;
    }

    isAdmin(): boolean {
        if (this.loginService.currentUser == null) return false;
        return this.loginService.currentUser.currentClaim == 'ADMIN';
    }

    hideTemplateEditor() {
        this.templateEditorVisible = false;
    }

    showTemplateEditor() {
        this.templateEditorVisible = true;
    }

    hasOxomiSupllierUpdates(menuItem: string) {
        return menuItem == this.translate.instant('Oxomi Sortiment') && this.oxomiService.oxomiUpdateAvailable;
    }

    canView(name: string): boolean {
        if (name == "classification" && !this.isAdmin() && !this.loginService.isManager) {
            return false;
        }
        return this.userManagemant.canView(name);
    }

    openSupportPage() {
        let email = this.loginService.currentUser.email;
        let lastName = this.loginService.currentUser.lastName;
        let firstName = this.loginService.currentUser.firstName;
        let link = `https://knowledge.nextpim.de/kb-tickets/new?email=${email}&lastname=${lastName}&firstname=${firstName}`;
        window.open(link, '_blank');
        this.hideAccountMenu();
    }

    toggleDataProcess(): void {
        this.isDataProcessOpen = !this.isDataProcessOpen;
    }


}
